import { useCallback, useState } from 'react';
import { DanelFileInfo } from '../components/DanelFileUploadItem/types';
import Actions from '../store/Actions';
import { showSnackbar } from '../context/Snackbar/SnackbarContext';
import { SnackbarType } from '../context/Snackbar/Types';

export const useVaultUpload = () => {
  const [isProcessingFiles, setIsProcessingFiles] = useState(false);
  const [hasUploadedFiles, setHasUploadedFiles] = useState(false);

  const processVaultFiles = useCallback(
    async (
      files: DanelFileInfo[],
      returnExcel: boolean = false
    ): Promise<void> => {
      try {
        setHasUploadedFiles(true);
        setIsProcessingFiles(true);

        const vaultFilesData = files.map(f => ({
          file: f.file,
          bank: f.bank!,
          name: f.name,
        }));

        await Actions.processVaultFiles(vaultFilesData, returnExcel);

        if (returnExcel) {
          showSnackbar({
            title: 'Success',
            type: SnackbarType.success,
            message:
              'Vault files processed successfully and saved to database. Excel file downloaded.',
          });
        } else {
          showSnackbar({
            title: 'Success',
            type: SnackbarType.success,
            message:
              'Vault files processed and saved to database successfully.',
          });
        }
      } catch {
        showSnackbar({
          title: 'Processing Failed',
          type: SnackbarType.error,
          message: 'Failed to process vault files. Please try again.',
        });
        setHasUploadedFiles(false);
      } finally {
        setIsProcessingFiles(false);
      }
    },
    []
  );

  const clearStates = useCallback(() => {
    setIsProcessingFiles(false);
    setHasUploadedFiles(false);
  }, []);

  return {
    isProcessingFiles,
    hasUploadedFiles,
    setIsProcessingFiles,
    setHasUploadedFiles,
    processVaultFiles,
    clearStates,
  };
};
